export default {
  state: {
    progress: false,
    confirm_modal: false,
    add_customer_modal: false,
    mark_as_sent_modal: false,
    print_warranty_modal: false,
    send_quotation_modal: false,
    forgot_password_modal: false,
    blinds_quotation_modal: false,
    print_manufacture_modal: false,
    send_whats_quotation_modal: false,
  },
  mutations: {
    toggle(state, toggleType) {
      state[toggleType] = !state[toggleType];
    },
    setToggle(state, data) {
      state[data.type] = data.bool;
    },
  },
  actions: {
    toggle({ commit }, toggleType) {
      commit('toggle', toggleType);
    },
    setToggle({ commit }, data) {
      commit('setToggle', data);
    },
  },
};
